<template>
  <component :animation-duration="duration" :is="'SpringSpinner'" :color="color" :size="size">
  </component>
</template>

<script>
import * as spinners from 'epic-spinners'

export default {
  name: 'LoadingSpinner',
  components: {
    ...spinners,
  },
  props: {
    duration: {
      type: Number,
      default: 1000,
    },
    color: {
      type: String,
      default: "#1C2D5A",
    },
    size: {
      type: Number,
      default: 80,
    },
  }
}
</script>